import React, { Fragment } from 'react';
import Image1 from '../Images/image1.jpg'
import Image3 from '../Images/image2.jpg'
import Image4 from '../Images/image3.jpg'
import Image5 from '../Images/image4.jpg'


const Images = () => {

    return (
        <div>
           <img src={Image1}/>
           <img src={Image3}/>
           <img src={Image4}/>
           <img src={Image5}/>
        </div>
    )
};
export default Images;